import React, { useEffect, useState, useRef } from "react";
import { Helmet } from 'react-helmet-async';
import { motion, useInView } from "framer-motion";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import LandingPageNavbar from "../components/LandingPageNavbar";
import { Container, Row, Col } from "react-bootstrap";
import Image3 from "../assets/images/company/image-3.jpg";
import Image5 from "../assets/images/company/image-5.png";

function About({ setPageTitle }) {

  const imageRef = useRef(null);
  const imageInView = useInView(imageRef, { once: true });

  useEffect(() => {
    setPageTitle("About - Bait Al Anaqah");
  }, [setPageTitle]);

  const image9Variants = {
    hidden: { opacity: 0, y: 80 },
    visible: { opacity: 1, y: 0 },
  };

  return (
    <>
    <Helmet>
        <meta name="keywords" content="Bait Al Anaqah, Bespoke, Uniforms, Alteration, Custom, Dubai" />
        <meta name="title" property="og:title" content={setPageTitle}></meta>
        <meta property="og:type" content="website" />
        <meta name="description" property="og:description" content="Experience the elegance of Bait Al Anaqah, where every creation tells a story and reflects your unique identity while honoring your values." />
        <meta name="image" property="og:image" content={Image3} />
        <link rel="canonical" href="https://baitalanaqah.com/about" />
      </Helmet>
      <LandingPageNavbar />
      <div className="vh-100 about-background d-flex align-items-center">
        <Container>
          <Row>
            <Col lg={8} className="me-auto text-start text-white py-5 px-4">
              <h2 className="display-1 mb-5">
                Exceeding Expectations Every Time.
              </h2>
              <p className="mb-5">
                At Bait Al Anaqah, we celebrate elegance in every garment we create. Established in 2020, we are a proud homegrown brand dedicated to offering a unique blend of traditional and contemporary styles that cater to the diverse fashion needs of our clientele.
              </p>
            </Col>
          </Row>
        </Container>
      </div>
      <div className="vh-100 about-background-two d-flex align-items-center">
        <Container>
          <Row>
            <Col lg={8} className="ms-auto text-start text-white py-5 px-4">
              <h2 className="display-1 mb-5">
                Crafting a Legacy of Excellence.
              </h2>
              <p className="mb-5">
                Founded by Mr Ali, a visionary leader with a passion for innovation and a legacy of success, Bait Al Anaqah stands as a testament to the power of perseverence, creativity and dedication. Mr Ali has shaped Bait Al Anaqah into a beacon of excellence, setting new standards and inspiring generations to come.
              </p>
            </Col>
          </Row>
        </Container>
      </div>
      <Container fluid className="bg-creme py-5">
        <Container>
          <Row>
            <Col lg={10} className="mx-auto text-start text-dark py-5">
              <h2 className="display-1 mb-5">
                Showcasing Remarkable Client Lineup
              </h2>
              <img src={Image5} className="img-fluid" />
            </Col>
          </Row>
        </Container>
      </Container>
      <Container fluid className="bg-black py-5">
        <Container>
          <Row>
            <Col lg={10} className="mx-auto text-center text-light py-5">
              <h2 className="display-1 mb-5">
                Connect with Us
              </h2>
              <p>
                Thank you for showing interest in Bait Al Anaqah, where elegance meets authenticity!
              </p>
              <p className="mb-5">
                We value your inquiries and are here to assist you with any questions regarding our exquisite collections or your shopping experience. Your thoughts and feedback are essential as we strive to elevate your journey with us.
              </p>
              <h5 className="fw-bold">Reach Out to Us</h5>
              <p>General Inquiries:</p>
              <p className="mb-5">
                For questions about our brand or products, drop us a line at:
                info@baitalanaqah.com
              </p>
              <h5 className="fw-bold">Customer Service Hours:</h5>
              <p>
              Monday - Friday
              </p>
              <p>
              9:00 AM - 5:00 PM (UAE Time)
              </p>
              <p className="mb-5">We are committed to providing exceptional service and aim to respond within 48 hours.</p>
              <h5 className="fw-bold">
              A Note to Our Valued Clients:
              </h5>
              <p>
              To ensure your message receives the attention it deserves, please direct your inquiries to the appropriate email address above.
              </p>
              <p>
              We look forward to connecting with you and helping you find the perfect piece that reflects your unique style and values.
              </p>
            </Col>
          </Row>
        </Container>
      </Container>
      <Footer />
    </>
  );
}

export default About;
